import { cn } from "@/utils/tailwind-helper";
import type { QRL } from "@builder.io/qwik";
import { component$ } from "@builder.io/qwik";
import { FancyImage } from "../../common-components/fancy-image/FancyImage";
import { useNavigation } from "../../hooks/useNavigation";
import { ChevronRightIcon } from "../../icons/ChevronRightIcon";
import type { IGenPage } from "../../services/graphql/__generated/sdk";

export const PageSearchResultItem = component$(
    ({ item, togglePageSearchRight$ }: { item: IGenPage; togglePageSearchRight$: QRL<() => void> }) => {
        const { getLink } = useNavigation();
        const link = getLink(item);
        // console.log(` PageSearchResultItem item`, item);
        if (!link.href) {
            return null;
        }
        return (
            <a href={link.href} onClick$={togglePageSearchRight$}>
                <div
                    key={item.id}
                    class={cn(
                        "group flex items-center justify-between gap-3 rounded-sm bg-white/80 pr-2 transition-colors duration-300 silver:gap-6 silver:pr-6",
                        "rounded-sm hover:bg-opacity-90",
                        !item.ogImage?.src && "py-2 pl-2 silver:py-4",
                    )}
                >
                    {item.ogImage?.src && (
                        <FancyImage
                            img={item.ogImage}
                            class={cn(
                                "h-[56px] w-[85px] silver:h-[84px] silver:w-[128px]",
                                "rounded-es-sm rounded-ss-sm",
                            )}
                            responsiveAspectRatio={{
                                bronze: 85 / 56,
                                silver: 128 / 84,
                            }}
                            responsiveMaxWidth={{ bronze: 200 }}
                            lazyload={false}
                        />
                    )}
                    <div class={cn("mr-auto flex flex-col items-start flex-1")}>
                        {item.title && (
                            <span
                                class={cn(
                                    "text-sm font-medium text-primary-500 transition-colors duration-300 group-hover:text-primary-500/80 silver:text-base",
                                )}
                            >
                                {item.title}
                            </span>
                        )}
                        <span
                            class={cn(
                                "text-sm font-normal text-primary-500/80 transition-colors duration-300 group-hover:text-primary-500/60",
                            )}
                        >
                            {item.parentPage?.name || ""}
                        </span>
                    </div>
                    <ChevronRightIcon
                        class={cn(
                            "h-6 w-6 text-primary-500/80 transition-colors duration-300 group-hover:text-primary-500",
                        )}
                    />
                </div>
            </a>
        );
    },
);
